import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'itm-spinner',
	templateUrl: './itm-spinner.component.html',
	styleUrls: ['./itm-spinner.component.scss']
})
export class ItmSpinnerComponent implements OnInit {

	constructor() { }

	ngOnInit() {
	}

}
